import { render, staticRenderFns } from "./InstructionalSummaryTable.vue?vue&type=template&id=ec67a826&scoped=true"
import script from "./InstructionalSummaryTable.vue?vue&type=script&lang=js"
export * from "./InstructionalSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./InstructionalSummaryTable.vue?vue&type=style&index=0&id=ec67a826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec67a826",
  null
  
)

export default component.exports